import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { Props } from "./types";
import styles from "./styles.scss";

function Filter({ filter, setFilter }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.filterDropdown}>
      <p className={styles.title}>
        {t("zonePage.reportsPage.filterOptions.title")}
      </p>
      <FilterMenu
        filter={filter}
        placeholder={t("zonePage.reportsPage.filterOptions.allProjects")}
        views={[
          "projects",
          "projectPortfolios",
          "projectsTags",
          "projectStatuses",
        ]}
        openedViews={["projects"]}
        setFilter={setFilter}
      />
      <FilterMenu
        filter={filter}
        placeholder={t(
          "zonePage.reportsPage.filterOptions.placeholderResource",
        )}
        views={["resources", "resourceTags", "groups"]}
        setFilter={setFilter}
      />
    </div>
  );
}

export { Filter };
